import { createReducer } from '@reduxjs/toolkit';
import type { Draft } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';
import type { Action } from 'redux';

import { LOAD_LOCATIONS_SUCCESS, UPDATE_LOCATION_SUCCESS } from './actions';
import type { Location } from './types';

export interface State {
  entities: { [id: string]: Location };
}

export const initialState: State = {
  entities: {},
};

type LoadLocationsSuccessAction = Action<typeof LOAD_LOCATIONS_SUCCESS> & {
  locations: Location[];
};

const loadLocationsSuccess = (
  state: Draft<State>,
  action: LoadLocationsSuccessAction
) => {
  state.entities = { ...state.entities, ..._.keyBy(action.locations, 'id') };
};

type UpdateLocationSuccessAction = Action<typeof UPDATE_LOCATION_SUCCESS> & {
  location: Location;
};

const updateLocationSuccess = (
  state: Draft<State>,
  action: UpdateLocationSuccessAction
) => {
  state.entities[action.location.id] = action.location;
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(LOAD_LOCATIONS_SUCCESS, loadLocationsSuccess);
  builder.addCase(UPDATE_LOCATION_SUCCESS, updateLocationSuccess);
});
